import { normalizeScannerConfig } from "react-native-ops-scanner";
import type { ScannerConfig } from "react-native-ops-scanner";

/**
 * Native QR / barcode scanner — implemented in react-native-ops-scanner
 * (shared with partner-db). Re-exported here so screens keep one import path,
 * plus tl-app's setup-4 flow → config mapping.
 */
export {
  isNativeCodeScannerAvailable,
  normalizeScannerConfig,
  scanCode,
} from "react-native-ops-scanner";
export type {
  ScanMode,
  ScannerConfig,
  ScanResult,
} from "react-native-ops-scanner";

/** Scan flows whose mode setup-4 sends in `scannerModes` (configReducer). */
export type ScanFlow = "receiving_rack" | "receiving_shipment";

/**
 * setup-4 `scannerModes[flow]` → scanner config. A flow the server didn't send
 * (older backend, failed boot call) gets no mode, i.e. the switcher.
 */
export const scannerConfigForFlow = (
  scannerModes: Partial<Record<ScanFlow, unknown>> | null | undefined,
  flow: ScanFlow,
): ScannerConfig => normalizeScannerConfig({ mode: scannerModes?.[flow] });
